import { render } from "./ScannedCertificate.vue?vue&type=template&id=181815b4&scoped=true"
import script from "./ScannedCertificate.vue?vue&type=script&lang=js"
export * from "./ScannedCertificate.vue?vue&type=script&lang=js"

import "./ScannedCertificate.vue?vue&type=style&index=0&id=181815b4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181815b4"]])

export default __exports__